
export class MccPhysicalPersonModel {
    id: number;
    mcc: number;
    mccDescription: string;
    serviceContract: number;
    institution: string;
    createdDate: string;
    lastModifiedDate: string;
}

export class MccPhysicalPersonHistoryModel {
    name: string;
    cpfCnpj: string;
    status: string;
    createdDate: string;
    institution: string;
    serviceContract: string;
    mcc: string;
    mccDescription: string;
}

export class SearchMccPhysicalPersonHistoryModel {
    id: number;
    institution: string;
    serviceContract: number;
    mcc: number;
    size: string;
    page: string;  
}

export class MccModel {
    mcc: string;
    merchantTariffDescription: string;
}

export class SearchMccPhysicalModel {
    institution: string; 
    serviceContract: string; 
    mcc: string;
    size: string;
    page: string;  
}   

export class MccPhysicalPersonSaveModel {
    mcc: number;
    institution: string; 
    serviceContract: number;
}

export class MccPhysicalPersonSavedModel {
    mccs: MccPhysicalPerson[];
    serviceContract: number;
}


export class MccPhysicalPersonDeleteModel {
    id: number; 
}

export class MccPhysicalPerson {
    mcc: number;
    mccDescription: number;
    institution: number; 
    serviceContract: number; 

}

export class MccDelete {
    mccNumber: number;
}

